/**
 * Admin dashboard translations (flat message map for react-intl + useIntl).
 * Split by module: auth, menu, common — merged at build time (no runtime HTTP).
 */
import enAuth from "./en/auth.json"
import enMenu from "./en/menu.json"
import enCommon from "./en/common.json"
import arAuth from "./ar/auth.json"
import arMenu from "./ar/menu.json"
import arCommon from "./ar/common.json"

const merge = (a, b, c) => ({ ...a, ...b, ...c })

export const enMessages = merge(enAuth, enMenu, enCommon)
export const arMessages = merge(arAuth, arMenu, arCommon)

export function getDefaultLocale() {
  if (typeof window === "undefined") return "en"
  try {
    const saved = window.localStorage.getItem("lang")
    if (saved === "ar" || saved === "en") return saved
    const nav = (navigator.language || "").toLowerCase()
    return nav.startsWith("ar") ? "ar" : "en"
  } catch (e) {
    return "en"
  }
}

export function messagesForLocale(locale) {
  return locale === "ar" ? arMessages : enMessages
}
